import * as EmojiPickerConstants from '../constants';
import EmojiPluginDataProvider from '../providers/EmojiPluginDataProvider';
import EmojiPickerViewState from '../store/schema/EmojiPickerViewState';
import { EditorViewState, PluginViewStateAdapter, PluginWithUI } from 'owa-editor';
import { PickerPluginOptions } from 'roosterjs-plugin-picker/lib/PickerDataProvider';
import EditorPickerPlugin from 'roosterjs-plugin-picker/lib/PickerPlugin';
import EmojiPickerResult from '../components/EmojiPickerResult';

/**
 * Wraps EmojiPickerDataProvider instantiation into the EmojiPickerPlugin. This way,
 * createComposePlugins doesn't have to manually instantiate the DataProvider.
 */
export default class EmojiPickerPlugin extends EditorPickerPlugin
    implements PluginWithUI<EmojiPickerViewState> {
    readonly adapter: PluginViewStateAdapter<EmojiPickerViewState>;
    readonly editorAdapter: PluginViewStateAdapter<EditorViewState>;
    constructor(
        adapter: PluginViewStateAdapter<EmojiPickerViewState>,
        editorAdapter: PluginViewStateAdapter<EditorViewState>,
        useFlexPane: boolean
    ) {
        const provider = new EmojiPluginDataProvider(adapter, editorAdapter, useFlexPane);
        const pickerOptions: PickerPluginOptions = {
            elementIdPrefix: EmojiPickerConstants.EMOJI_ELEMENT_ID_PREFIX,
            changeSource: EmojiPickerConstants.EMOJI_CHANGE_SOURCE,
            triggerCharacter: EmojiPickerConstants.EMOJI_PICKER_TRIGGER_CHARACTER,
            isHorizontal: true,
            handleAutoComplete: true,
            suggestionsLabel: EmojiPickerConstants.EMOJI_SUGGESTIONS_LABEL,
            suggestionLabelPrefix: EmojiPickerConstants.EMOJI_SUGGESTION_LABEL_PREFIX,
        };

        super(provider, pickerOptions);
        this.adapter = adapter;
        this.editorAdapter = editorAdapter;
    }

    public getUIComponentClass() {
        return EmojiPickerResult;
    }

    public getName() {
        return 'EmojiPicker';
    }
}
